import { render, staticRenderFns } from "./Wonderful.vue?vue&type=template&id=0cc1abea&"
import script from "./Wonderful.vue?vue&type=script&lang=js&"
export * from "./Wonderful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports